import { Navigate, useLocation } from "react-router-dom";
import { useSbAuth } from "@/context/SupabaseAuthContext";
import { Spinner } from "@/components/library/states";

function FullLoader() {
  return <div className="min-h-screen grid place-items-center bg-background"><Spinner label="Laddar konto…" /></div>;
}

// Requires an authenticated session.
export function ProtectedRoute({ children }) {
  const { session, loading } = useSbAuth();
  const location = useLocation();
  if (loading) return <FullLoader />;
  if (!session) return <Navigate to="/konto/login" replace state={{ from: location.pathname }} />;
  return children;
}

// Requires a selected restaurant (tenant context).
export function RequireRestaurant({ children }) {
  const { currentRestaurant, loading } = useSbAuth();
  if (loading) return <FullLoader />;
  if (!currentRestaurant) return <Navigate to="/konto/valj" replace />;
  return children;
}

// Requires the user's role to meet a minimum capability.
export function RequirePermission({ permission, children, fallback = null }) {
  const { hasPermission, loading } = useSbAuth();
  if (loading) return <FullLoader />;
  if (!hasPermission(permission)) {
    return fallback || (
      <div className="p-8 text-center text-sm text-muted-foreground" data-testid="permission-denied">
        Du har inte behörighet att se detta.
      </div>
    );
  }
  return children;
}

// Inline guard for buttons/sections.
export function Can({ permission, children, fallback = null }) {
  const { hasPermission } = useSbAuth();
  return hasPermission(permission) ? children : fallback;
}
